import React from 'react';
import { cx } from './_cx';

/**
 * Container (UI primitive)
 *
 * Constrains content width and applies consistent horizontal padding.
 */
export function Container({ as, className, ...props }) {
  const Component = as || 'div';
  return <Component className={cx('pv-container', className)} {...props} />;
}

